<template>
    <section class="d-flex flex-column mt-2 mb-3 w-100">
        <section class="d-flex flex-column text-primary text-center" v-if="isLoading && !isError">
            <i class="far fa-calendar-check animated flash infinite mb-2 font-size-base"></i>
            <strong>Checking selected dates against Patient's frequency...</strong>
        </section>
        <template v-if="isError && !isLoading">
            <h3>Error</h3>
            <h6 class="mb-3">
                There was a problem while checking selected dates against Patient's frequency. Please try again.
            </h6>
            <button class="btn btn-primary" @click="checkFrequencyCompliance()">Try Again</button>
            <p>
                <!-- <small>
                    If the problem persists, click <report-error-link>here</report-error-link> to report it.
                </small> -->
            </p>
        </template>
        <template v-if="!isLoading && !isError && availableFrequencies.length > 0">
            <section class="d-flex mb-2 font-size-xl">
                <b>Task:</b>
                <span class="ms-1 me-2">{{ selectedTask.name }}</span>
                <b>Discipline:</b>
                <span class="ms-1 me-2">{{ disciplineName }}</span>
            </section>
            <table class="table table-responsive-md border border-gray mb-0">
                <thead>
                    <tr class="bg-table-header">
                        <th>Selected Date</th>
                        <th>Frequency</th>
                    </tr>
                </thead>
                <!-- LIST -->
                <tbody>
                    <tr v-for="item of availableFrequencies">
                        <td>
                            <strong class="${frequency ? 'text-success' : 'text-danger'}">
                                {{ formatDate(item.visitDate) }}
                            </strong>
                            <i class="ms-1 fas fa-check-circle text-success" v-if="item.frequency"></i>
                            <i class="ms-1 fas fa-exclamation-triangle text-danger" v-else></i>
                        </td>
                        <td>
                            <template v-if="item.frequency">
                                <span class="me-1">${frequency}</span>
                                ({{ formatDate(item.startDate) }} - {{ formatDate(item.endDate) }})
                            </template>
                            <template v-else>
                                <strong class="text-danger">Outside Frequency</strong>
                            </template>
                        </td>
                        <!-- <td class="text-end">
                            <button class="btn table-btn btn-outline-danger btn-xs"
                                @click="deleteVisitDate(visitDate)" v-if="!frequency">
                                Delete
                            </button>
                            <i class="text-default" v-else>Within Frequency</i>
                        </td> -->
                    </tr>
                </tbody>
            </table>
        </template>
    </section>
</template>

<script lang="ts" src="./FrequencyCheck.ts"></script>
